import { useEffect } from "react";
import { MENU_LIST } from "../../components/SignInUp/helper";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { isValidMotionProp, motion } from "framer-motion";
import { commonOpacity, gameListFromBottom } from "../../animateConstant";
import {
  Box,
  Flex,
  chakra,
  shouldForwardProp,
  useColorModeValue,
  Text,
  useClipboard,
  Grid,
  Image,
} from "@chakra-ui/react";
import ProfileCardNotLogin from "./components/profileCardNotLogin";
import useCheckLogin from "../../hook/useCheckLogin";
import CommonSelectTab from "./components/commonSelectTab";
import ProfileCard from "./components/profileCard";
import CachePop from "./components/cachePop";
import ClearCashPop from "./components/clearCashPop";
import useLogoutButton from "./components/useLogoutButton";
import { COMMON_ALT, COMMON_WEB_PATH } from "../../constant";
import { AiFillCaretRight } from "react-icons/ai";

const motionProps = {
  initial: commonOpacity.initial,
  animate: commonOpacity.animate,
  exit: commonOpacity.exit,
  transition: commonOpacity.transition,
};

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const Aside = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { isLogin } = useCheckLogin();

  const { onCopy, value, setValue, hasCopied } = useClipboard("");

  const memberData = useSelector((state) => state.isMemberInfo);
  const cachePop = useSelector((state) => state.isCachePop);
  const clearCashPop = useSelector((state) => state.isClearCashPop);
  const dispatch = useDispatch();

  const { asideLogoutBtn } = useLogoutButton();

  const menuColor = useColorModeValue("light.100", "light.100");
  const textColor = useColorModeValue("dark.100", "#f4d3ff");
  const iconBg = useColorModeValue("#EFEFF5", "dark.200");

  const menu = MENU_LIST({ className: "", dispatch });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setValue(memberData?.uid);
  }, [memberData]);

  return (
    <ChakraBox
      display="flex"
      flexDirection={`column`}
      gap={{
        base: "3px",
        md: "5px",
      }}
      overflowY="scroll"
      h="100%"
      {...motionProps}
      className="no-scrollbar"
    >
      <Flex
        alignItems={`center`}
        justifyContent={{
          base: "space-between",
          md: "flex-start",
        }}
      >
        {" "}
        {/* {isLogin && (
          <ProfileButton
            className={{
              bg: profileIconBg,
            }}
          />
        )} */}
        <Flex direction={`column`} ml="10px"></Flex>
        <Box
          display={{
            base: "block",
            md: "none",
          }}
          position={"absolute"}
          top="10px"
          right="8px"
          color="special.100"
          fontSize={`4xl`}
        >
          <Link to="../">
            {/* <IoCloseOutline className="cursor-pointer" />  */}
            <Image
              src={`${COMMON_WEB_PATH}/911TW/closeBTN.webp`}
              width={"35px"}
              alt={COMMON_ALT}
              _hover={{
                filter: "brightness(1.1)",
              }}
            />
          </Link>
        </Box>
      </Flex>
      <Box mb="10px">
        {isLogin ? <ProfileCard /> : <ProfileCardNotLogin />}
        {/* <BalanceCard /> */}
      </Box>
      {isLogin && (
        <Box mb="10px" px="5px">
          <CommonSelectTab />
        </Box>
      )}
      <Flex as="section" direction={`column`} px="5px" gap="10px">
        {Object?.keys(menu).map((route) => {
          const list = menu[route];
          return (
            <ChakraBox
              {...gameListFromBottom}
              gap="5px"
              as="section"
              //borderRadius={`20px`}
              //shadow="0px 2px 5px #a2a2a2"
              //bg={cardBg}
              overflow="hidden"
              borderBottom="1px solid"
              //borderTop={"1px solid"}
              borderBottomColor={"#3c2764"}
              //boxShadow={`0 4px 2px -2px #2d2934`}
            >
              <Flex
                gap={"5px"}
                w={"100%"}
                alignItems={`center`}
                borderBottom="1px solid"
                //borderTop={"1px solid"}
                borderBottomColor={"#3c2764"}
                boxShadow={`0px 1px 5px #3e2968`}
              >
                <Text
                  py="10px"
                  px="20px"
                  color="#f4d3ff"
                  fontSize="md"
                  fontWeight={`600`}
                  //bg="brand.500"
                  // borderBottom="1px solid"
                  // borderColor="brand.100"
                  position="relative"
                  textShadow="0px 0px 5px #BE00FF"
                  // _before={{
                  //   content: "''",
                  //   position: "absolute",
                  //   left: "0px",
                  //   bottom: "10px",
                  //   borderRightRadius: "10px",
                  //   width: "5px",
                  //   height: "20px",
                  //   bg: "brand.300",
                  // }}
                >
                  {i18n(route)}
                </Text>
                <Text color="#f4d3ff" textShadow="0px 0px 5px #BE00FF">
                  <AiFillCaretRight />
                </Text>
              </Flex>
              <Grid
                pt="15px"
                pb="30px"
                gridTemplateColumns={`repeat(4, minmax(0, 1fr))`}
                gap="10px"
                overflow="hidden"
                px="20px"
              >
                {list
                  ?.filter((route) => {
                    return !route?.hidden;
                  })
                  ?.filter((item) => {
                    if (item.auth) {
                      if (item.verify) {
                        return false;
                      }
                      return isLogin === item.auth;
                    } else {
                      return true;
                    }
                  })
                  ?.map((item) => {
                    return (
                      <>
                        <Box
                          role="group"
                          onClick={() => {
                            if (item.func) {
                              item.func();
                              return;
                            }
                            if (item.hashed || item.link === "service-group") {
                              // 特殊處理 service-group
                              navigate(`/${item.link}`);
                            } else {
                              navigate(`../profile/${item.link}`);
                            }
                          }}
                          color={menuColor}
                          // bg={
                          //   location.pathname.includes(item.link)
                          //     ? activeMenuBg
                          //     : menuBg
                          // }
                          display="flex"
                          gap="5px"
                          flexDirection={`column`}
                          alignItems={`center`}
                          // justifyContent={`center`}
                          // _hover={{
                          //   color: "brand.500",
                          //   bg: menuHoverBg,
                          // }}
                          cursor={`pointer`}
                          className={`${item.className}`}
                        >
                          <Box
                            w="45px"
                            h="45px"
                            display="flex"
                            alignItems={`center`}
                            justifyContent={`center`}
                            borderRadius={`full`}
                            bg={iconBg}
                          >
                            {/* <Icon
                              as={item.icon}
                              fontSize="xl"
                              color={iconColor}
                            /> */}
                            <Image
                              src={item.image}
                              alt={item.text}
                              boxSize="60px"
                              objectFit="contain"
                            />
                          </Box>
                          <Text
                            fontSize="sm"
                            letterSpacing={`tight`}
                            // _groupHover={{
                            //   fontWeight: `700`,
                            // }}
                            w="100%"
                            textAlign={`center`}
                            // className="text-overflow"
                            fontWeight={
                              location.pathname.includes(item.link)
                                ? "700"
                                : "400"
                            }
                            color={textColor}
                            textShadow="0px 0px 5px #BE00FF"
                          >
                            {item.text}
                          </Text>

                          {/* <HiChevronRight className="md:hidden" /> */}
                        </Box>
                        {item.children && item.children}
                      </>
                    );
                  })}
              </Grid>
            </ChakraBox>
          );
        })}
      </Flex>
      {asideLogoutBtn}
      {cachePop && <CachePop />}
      {clearCashPop && <ClearCashPop />}
    </ChakraBox>
  );
};

export default Aside;
